import { useCallback, useEffect } from 'react';

import { resizeSignature } from './tools';

export const useCanvasResize = (signature) => {
    const handleResizeCanvas = useCallback(() => resizeSignature(signature), [signature]);

    useEffect(() => {
        window.addEventListener('resize', handleResizeCanvas);

        return () => window.removeEventListener('resize', handleResizeCanvas);
    }, [signature]);
};
